import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-hairline bg-surface px-3 py-1 text-sm text-ink-900 transition-colors',
        // Phones: 44 px target, 16 px text so iOS doesn't zoom on focus.
        'max-sm:h-11 max-sm:text-base',
        'placeholder:text-ink-400',
        'hover:border-hairline-bold focus:border-primary focus-visible:outline-none focus:shadow-[0_0_0_3px_var(--primary-tint)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'file:border-0 file:bg-transparent file:text-sm file:font-medium',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
